export default __webpack_public_path__ + "static/media/flag_pop.431e7ad3.svg";